export const QUERY_KEYS = {
  GLOBAL: {
    FETCH_ENUM: "GLOBAL_FETCH_ENUM",
    MASTER_REGION: "MASTER_REGION",
    MASTER_LIVING_RELATIONSHIP: "MASTER_LIVING_RELATIONSHIP",
    MASTER_MAIN_OCCUPATION: "MASTER_MAIN_OCCUPATION",
    MASTER_MAIN_INDUSTRY: "MASTER_MAIN_INDUSTRY",
    MASTER_LOCAL_GOVERNMENT_COUNTER: "MASTER_LOCAL_GOVERNMENT_COUNTER",
    MASTER_LANGUAGE_TEST: "MASTER_LANGUAGE_TEST",
    MASTER_SUPPORT_LANGUAGE: "MASTER_SUPPORT_LANGUAGE",
    MASTER_SKILL_TEST: "MASTER_SKILL_TEST",
    MASTER_SPECIFIC_INDUSTRY: "MASTER_SPECIFIC_INDUSTRY",
    MASTER_MAJOR: "MASTER_MAJOR",
    MASTER_COMPANY_SPECIFIC_INDUSTRY: "MASTER_COMPANY_SPECIFIC_INDUSTRY",
    MASTER_RESIDENCE_STATUS: "MASTER_RESIDENCE_STATUS",
    FETCH_MAINTENANCE: "GLOBAL_FETCH_MAINTENANCE",
    PROVINCES_MUNICIPALITIES: "PROVINCES_MUNICIPALITIES",
    FETCH_PREFECTURE_AND_MUNICIPALITY_BY_ZIP_CODE: "FETCH_PREFECTURE_AND_MUNICIPALITY_BY_ZIP_CODE",
    FETCH_ADDRESS_CODES: "FETCH_ADDRESS_CODES",
  },
  FILE: {
    FETCH_DETAIL: "FILE_FETCH_DETAIL",
    FETCH_INFO: "FILE_FETCH_INFO",
    FETCH_SIGNED_URL: "FILE_FETCH_SIGNED_URL",
  },
  USER: {
    FETCH_ME: "USER_FETCH_ME",
  },
  CUSTOMER_USER: {
    FETCH_LIST: "CUSTOMER_USER_FETCH_LIST",
    FETCH_DETAIL: "CUSTOMER_USER_FETCH_DETAIL",
    FETCH_COUNT: "CUSTOMER_USER_FETCH_COUNT",
  },
  ORGANIZATION: {
    FETCH_ME: "ORGANIZATION_FETCH_ME",
  },
  PRODUCT_CONTRACT: {
    FETCH_LIST: "PRODUCT_CONTRACT_FETCH_LIST",
  },
  MASTER_PRODUCT: {
    FETCH_LIST: "MASTER_PRODUCT_FETCH_LIST",
  },
  AUTH: {
    VERIFY_RESET_TOKEN: "AUTH_VERIFY_RESET_TOKEN",
  },
  INFORMATION: {
    FETCH_LIST: "INFORMATION_FETCH_LIST",
    FETCH_DETAIL: "INFORMATION_FETCH_DETAIL",
    CHECK_UNREAD: "INFORMATION_CHECK_UNREAD",
  },

  CONTACT_TYPE: {
    FETCH_LIST: "CONTACT_TYPE_FETCH_LIST",
  },
  USER_SETTING: {
    FETCH_DETAIL: "USER_SETTING_FETCH_DETAIL",
  },
  PASSKEY: {
    LIST: "PASSKEY_LIST",
  },
} as const;
